import { render, staticRenderFns } from "./GMakingMoneyTips.vue?vue&type=template&id=9dac4a5a&scoped=true&"
import script from "./GMakingMoneyTips.vue?vue&type=script&lang=js&"
export * from "./GMakingMoneyTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dac4a5a",
  null
  
)

export default component.exports